import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import history from '../../../history';

// react-markdown 8 reads the text from `children` (the old `source` prop is ignored,
// which rendered every assistant reply empty). Links to the app itself navigate
// inside the SPA instead of reloading it; anything else opens in a new tab.
const isInternal = (href) => typeof href === 'string' && /^\/(?!\/)/.test(href);

export function AssistantLink({ href, children }) {
  if (isInternal(href)) {
    return (
      <a
        href={href}
        onClick={(e) => {
          e.preventDefault();
          history.push(href);
        }}
      >
        {children}
      </a>
    );
  }
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}

AssistantLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
};

const MARKDOWN_COMPONENTS = { a: AssistantLink };

function AssistantMessage({ message }) {
  const isUser = message.role === 'user';

  return (
    <div
      className={`assistant-message ${
        isUser ? 'assistant-message-user' : 'assistant-message-assistant'
      }${message.isError ? ' assistant-message-error' : ''}`}
    >
      <div className="assistant-message-content">
        {message.attachmentName && (
          <div className="assistant-message-attachment">
            <span role="img" aria-label="Attachment">
              📎
            </span>{' '}
            {message.attachmentName}
          </div>
        )}
        <div className="assistant-message-text">
          {isUser ? (
            message.content
          ) : (
            <ReactMarkdown components={MARKDOWN_COMPONENTS}>
              {message.content}
            </ReactMarkdown>
          )}
        </div>
        {message.local && !isUser && (
          <div className="assistant-message-local-note">
            This exchange isn&apos;t saved to your chat history.
          </div>
        )}
      </div>
      <div className="assistant-message-arrow" />
    </div>
  );
}

AssistantMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string,
    role: PropTypes.oneOf(['user', 'assistant']).isRequired,
    content: PropTypes.string.isRequired,
    createdAt: PropTypes.string,
    attachmentName: PropTypes.string,
    isError: PropTypes.bool,
    local: PropTypes.bool,
  }).isRequired,
};

export default AssistantMessage;
